import { sdkRequest } from '@eventbrite/legacy-infra.http';
import { User } from '../types';

export const getUser = async (): Promise<User> => {
    const user = await sdkRequest('/api/v3/users/me/');
    return user;
};
